import { useRecoilValue, useSetRecoilState } from "recoil";
import styled, { css, keyframes } from "styled-components";
import GameVersion from "../enums/GameVersion";
import gameVersionState from "../state/game-version-state";
import loseScreenState from "../state/lose-screen-state";
import { emoji, FullscreenOverlay } from "./common";

const animation = keyframes`
  from {
    transform: rotate(-10deg);
  }

  to {
    transform: rotate(10deg);
  }
`;

const Emoji = styled.span<{ animate?: boolean }>`
  font-size: 8rem;
  ${({ animate }) =>
    animate
      ? css`
          animation: ${animation} 1s ease-in-out infinite alternate;
        `
      : null}

  transform-origin: 25% 35%;
  > * {
    filter: drop-shadow(${({ theme }) => theme.shadow(6)});
  }
`;

const LoseScreen: React.FC = () => {
  const setLoseScreen = useSetRecoilState(loseScreenState);
  const gameVersion = useRecoilValue(gameVersionState);

  const handleClick = () => {
    setLoseScreen(false);
  };

  return (
    <FullscreenOverlay onClick={handleClick}>
      <Emoji animate={gameVersion === GameVersion.fancy}>{emoji("👎")}</Emoji>
    </FullscreenOverlay>
  );
};

export default LoseScreen;
